// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 2개종목비교 팝업 (StockCompareModal) */

.scm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scm-panel {
  background: #fff;
  border-radius: 12px;
  width: 1180px;
  max-width: 97vw;
  max-height: 97vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22);
}

@media (max-width: 768px) {
  .scm-overlay { align-items: flex-end; }
  .scm-panel {
    width: 100%;
    max-width: 100%;
    max-height: 94vh;
    border-radius: 16px 16px 0 0;
  }
}

.scm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 10px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
  gap: 12px;
}

.scm-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.scm-title-sub {
  font-size: 12px;
  font-weight: 500;
  color: #888;
}

.scm-close {
  border: none;
  background: transparent;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
}
.scm-close:hover { color: #333; }

.scm-period-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.scm-period-btn {
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 14px;
  padding: 4px 12px;
  font-size: 12px;
  color: #555;
  cursor: pointer;
}
.scm-period-btn.active {
  background: #2a78d6;
  border-color: #2a78d6;
  color: #fff;
  font-weight: 600;
}

.scm-custom-range {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 6px;
}
.scm-custom-range input[type="date"] {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 12px;
}

.scm-apply-btn {
  border: none;
  background: #2a78d6;
  color: #fff;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
}

.scm-body {
  padding: 14px 16px 18px;
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.scm-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  color: #888;
  font-size: 13px;
  text-align: center;
  line-height: 1.7;
}

.scm-summary {
  margin-top: 10px;
  padding: 10px 12px;
  background: #f8f9fb;
  border: 1px solid #eef0f3;
  border-radius: 6px;
  font-size: 12px;
  color: #444;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.scm-sep { color: #ccc; }
`, "",{"version":3,"sources":["webpack://./src/components/common/StockCompareModal.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,eAAe,qBAAqB,EAAE;EACtC;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA,mBAAmB,WAAW,EAAE;;AAEhC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA,WAAW,WAAW,EAAE","sourcesContent":["/* 2개종목비교 팝업 (StockCompareModal) */\n\n.scm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 9000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scm-panel {\n  background: #fff;\n  border-radius: 12px;\n  width: 1180px;\n  max-width: 97vw;\n  max-height: 97vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22);\n}\n\n@media (max-width: 768px) {\n  .scm-overlay { align-items: flex-end; }\n  .scm-panel {\n    width: 100%;\n    max-width: 100%;\n    max-height: 94vh;\n    border-radius: 16px 16px 0 0;\n  }\n}\n\n.scm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px 10px;\n  border-bottom: 1px solid #eee;\n  flex-shrink: 0;\n  gap: 12px;\n}\n\n.scm-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a2e;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.scm-title-sub {\n  font-size: 12px;\n  font-weight: 500;\n  color: #888;\n}\n\n.scm-close {\n  border: none;\n  background: transparent;\n  font-size: 16px;\n  color: #999;\n  cursor: pointer;\n  line-height: 1;\n  padding: 4px;\n}\n.scm-close:hover { color: #333; }\n\n.scm-period-bar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 10px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  flex-shrink: 0;\n}\n\n.scm-period-btn {\n  border: 1px solid #ddd;\n  background: #fff;\n  border-radius: 14px;\n  padding: 4px 12px;\n  font-size: 12px;\n  color: #555;\n  cursor: pointer;\n}\n.scm-period-btn.active {\n  background: #2a78d6;\n  border-color: #2a78d6;\n  color: #fff;\n  font-weight: 600;\n}\n\n.scm-custom-range {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 6px;\n}\n.scm-custom-range input[type=\"date\"] {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 3px 6px;\n  font-size: 12px;\n}\n\n.scm-apply-btn {\n  border: none;\n  background: #2a78d6;\n  color: #fff;\n  border-radius: 4px;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.scm-body {\n  padding: 14px 16px 18px;\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.scm-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 260px;\n  color: #888;\n  font-size: 13px;\n  text-align: center;\n  line-height: 1.7;\n}\n\n.scm-summary {\n  margin-top: 10px;\n  padding: 10px 12px;\n  background: #f8f9fb;\n  border: 1px solid #eef0f3;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #444;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.scm-sep { color: #ccc; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
